import { createFileRoute } from '@tanstack/react-router';

import { NetworkTemplatePage } from '../features/a2v/networkTemplate/components/NetworkTemplatePage/NetworkTemplatePage';

export const Route = createFileRoute('/supply/publishers_/$publisherId/details/a2v')({
  component: PublisherA2vRoute,
});

function PublisherA2vRoute() {
  const { publisherId } = Route.useParams();
  return <NetworkTemplatePage publisherId={publisherId} />;
}
